export default {
  view: "Voir",
  recharge: "Recharger",
  remark: "Remarque",
  status: "Statut",
  sort: "Tri",
  enable: "Activer",
  disable: "Désactiver",
  show: "Afficher",
  hide: "Masquer",
  export: "Exporter",
  batchPass: "Valider en lot",
  batchReject: "Refuser en lot",
  batchDelete: "Supprimer en lot",
  pass: "Valider",
  reject: "Refuser",
  online: "En ligne",
  offline: "Hors ligne",
  all: "Tout",
  today: "J.",
  total: "T.",
  paid: "Payé",
  pending: "Att.",
  male: "Homme",
  female: "Femme",
  certified: "Certifié",
  notCertified: "Non certifié",
  reviewing: "En cours",
  authRejected: "Refusé",
  paidBond: "Versé",
  regTime: "Date d'inscription",
  addTime: "Date d'ajout",
  contact: "Contact",
  realName: "Nom réel",
  account: "Compte",
  phone: "Téléphone",
  storeNo: "N° marchand",
  merchantNo: "N° marchand : ",
  rechargeAmount: "Montant",
  rechargeAmountPh: "Saisir le montant",
  remarkPh: "Saisir une remarque",
  rechargeDialog: "Recharge",
  pricingRule: "Règle tarifaire",
  orderCountToday: "Commandes",
  orderCountDispatch: "Envois",
  balance: "Solde (yuans)",
  withdrawable: "Solde retirable (yuans)",
  bond: "Caution",
  workStatus: "Statut",
  riderStatus: "Statut livreur",
  riderAccount: "Compte livreur",
  riderLevel: "Niveau",
  todayRank: "Aujourd'hui",
  weekRank: "Cette semaine",
  monthRank: "Ce mois",
  orderCount: "Commandes",
  payAmount: "Montant payé",
  todayOrdersCol: "Commandes du jour",
  merchantName: "Marchand",
  merchantNamePh: "Nom du marchand",
  merchantCodePh: "N° marchand",
  storeAddress: "Adresse",
  storeApiInfo: "Infos API",
  cancelBtn: "Annuler",
  okBtn: "Confirmer",
};
